{
	"layout": {
		"circle-sort-key": [
			"match",
			["get", "intersection_class"],
			"Class 1",
			3,
			"Class 2",
			2,
			"Class 3",
			1,
			0
		]
	},
	"paint": {
		"circle-color": [
			"match",
			["get", "intersection_class"],
			"Class 1",
			"#ED2938",
			"Class 2",
			"#FFAA1C",
			"Class 3",
			"#41C300",
			"#ccc"
		],
		"circle-opacity": 0.9,
		"circle-radius": ["interpolate", ["linear"], ["zoom"], 5, 2, 6, 5],
		"circle-stroke-width": 1,
		"circle-stroke-color": "#333",
		"circle-stroke-opacity": 0.7
	}
}
